import React from 'react';
import styles from './TraitDisplayCard.module.scss';
import { BaseTraitCard, TraitPreview, TraitType } from './BaseTraitCard';

export type TraitDisplayCardProps = {
  name: string;
  description: string;
  type: TraitType;
  src?: string;
  small?: boolean;
};

// TODO: make this component generic and decouple it from trait information
export const TraitDisplayCard = (props: TraitDisplayCardProps) => {
  const preview = props.src ? (
    <TraitPreview
      className={props.small ? styles.traitPreviewSmall : styles.traitPreview}
      src={props.src}
      type={props.type}
    />
  ) : (
    <></>
  );
  return (
    <BaseTraitCard
      className={props.small ? styles.traitDisplayCardSmall : styles.traitDisplayCard}
      preview={preview}
      {...props}
    />
  );
};
